export const classes = { readonly: 'dark' };
